function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgFidelity = function SvgFidelity(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 40 26",
    style: {
      enableBackground: "new 0 0 40 26"
    },
    xmlSpace: "preserve"
  }, props), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#128741"
    },
    d: "M0 0h40v26H0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20 2.275C14.085 2.275 9.275 7.085 9.275 13S14.085 23.725 20 23.725 30.725 18.915 30.725 13 25.915 2.275 20 2.275zM26.435 20.8l-.26-.455-2.405-4.095 3.77 2.08s.065 0 0-.065L22.6 14.04l6.37.975-.065-.065-5.98-2.08 6.305-1.495v-.065l-6.37.455 4.615-3.445.455-.39s-.065-.065-.065 0l-4.81 2.405-.845.455 3.12-5.46s0-.065 0 0l-4.03 4.81.65-6.305h-.065L20 9.88l-.52-1.885-1.105-4.42h-.065v.52l.455 5.915-3.835-5.005 2.925 5.59-5.525-2.99 4.42 3.64.52.455-6.37-.65v.065l6.045 1.755-6.045 1.755v.065l6.24-.715-4.875 4.16v.065h.065l3.965-2.145.91-1.495h1.04l-.715-.52L20 10.205l-1.495 4.615h3.705l1.04.65h-4.875l-1.95 6.11-.26.585c-2.47-.91-4.68-3.12-5.655-5.59-.91-2.34-.91-5.135.065-7.605s3.25-4.68 5.72-5.59c1.95-.78 4.55-.91 6.565-.26 2.47.715 4.55 2.405 5.915 4.55 1.495 2.405 1.82 5.525.975 8.255-.65 1.885-1.69 3.64-3.315 4.875z",
    style: {
      fill: "#fff"
    }
  }));
};
export default SvgFidelity;